import { useNavigate } from "react-router";
import { Link } from "react-router-dom";

import { useAuth0 } from "../../../contexts/AuthManager/Auth";
import { ErrorStyles } from "./ErrorComponent";

const Error400 = () => {
  const navigate = useNavigate();
  const authContext = useAuth0();

  return (
    <ErrorStyles>
      <div className="raven-error">
        <div>400: There{`'`}s nothing here!</div>
        <div>
          Click to{" "}
          <span
            onClick={() => {
              // go back 2 pages
              navigate(-2);
            }}
            className="raven-error-retry"
          >
            go back
          </span>{" "}
          or{" "}
          <span
            onClick={() => {
              navigate("/");
            }}
            className="raven-error-retry"
          >
            return to the main page
          </span>
          . You might also try to{" "}
          <span
            onClick={() => {
              navigate("/");
              authContext?.loginWithRedirect();
            }}
            className="raven-error-retry"
          >
            sign-in again
          </span>
          .
        </div>
        <div>
          Still confused? Don{`'`}t hesitate to{" "}
          <Link to={"/unauthorized/help"}>reach out for assistance</Link>.
        </div>
      </div>
    </ErrorStyles>
  );
};
export default Error400;
